module.exports = __webpack_public_path__ + "images/category_lp/audio_instrument/new/assessment_achievements/5@2x_8e777e3e7ff9f72661a1bdc39c4e2f91.png";